import { render, staticRenderFns } from "./ModuleNavigation.vue?vue&type=template&id=abb6f3aa"
import script from "./ModuleNavigation.vue?vue&type=script&lang=js"
export * from "./ModuleNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports